/**
 * Centralized authenticated fetch wrapper.
 * Adds Authorization header from localStorage and handles 401 responses.
 */

let isRedirecting = false;

export async function authFetch(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const token = localStorage.getItem('auth_token');

  const headers = new Headers(options.headers || {});

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  // Set Content-Type to application/json by default, but NOT when:
  // - A Content-Type is already explicitly set
  // - The body is FormData (browser must set multipart boundary automatically)
  if (!headers.has('Content-Type') && !(options.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401 && !isRedirecting) {
    isRedirecting = true;
    localStorage.removeItem('auth_token');
    localStorage.removeItem('operator_user');
    if (window.location.pathname.startsWith('/super-admin')) {
      window.location.href = '/super-admin';
    } else {
      window.location.href = '/dashboard';
    }
  }

  return response;
}
